import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const CLASSIFIEDS = {
  ROOT: `${PRIVATE_ROOT}/community/classifieds`,
  MY_ADS: `${PRIVATE_ROOT}/community/classifieds/my-ads`,
  FAVORITES: `${PRIVATE_ROOT}/community/classifieds/favorites`,
}
export const ADD_CLASSIFIED = `${PRIVATE_ROOT}/community/classifieds/add`
export const EDIT_CLASSIFIED = `${PRIVATE_ROOT}/community/classifieds/:id/edit`
export const VIEW_CLASSIFIED = `${PRIVATE_ROOT}/community/classifieds/:id/view`
